<script setup lang="ts">
import { BellIcon } from "@heroicons/vue/24/outline"
</script>

<template>
  <button
    type="button"
    class="relative rounded-full p-2 text-slate-600 transition hover:bg-slate-100 hover:text-slate-900"
    aria-label="Notificacoes"
  >
    <BellIcon class="size-6" />
    <span class="absolute right-2 top-2 size-2 rounded-full bg-red-500" aria-hidden="true" />
  </button>
</template>

